import { render } from "./AdminManualIdentityValidationReview.vue?vue&type=template&id=88368b8a&scoped=true"
import script from "./AdminManualIdentityValidationReview.vue?vue&type=script&lang=js"
export * from "./AdminManualIdentityValidationReview.vue?vue&type=script&lang=js"

import "./AdminManualIdentityValidationReview.vue?vue&type=style&index=0&id=88368b8a&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88368b8a"]])

export default __exports__